import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Newsletter',
  basePath: '/newsletter',
  columns: [
    { key: 'email', label: 'Email', sortable: true },
    { key: 'active', label: 'Active', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'email', label: 'Email', type: 'text', required: true },
    { key: 'active', label: 'Active', type: 'yesno', defaultValue: '0' },
  ],
  defaultSort: { field: 'email', dir: 'asc' },
});
